var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAiModelPositionButton = function SvgIconAiModelPositionButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M3.674 4.586c.54-.556 1.98-2.75 2.75-2.75S8.63 4.03 9.171 4.586m-2.75-1.97v17.553m10.997-7.338c.556.541 2.75 1.98 2.75 2.75s-2.194 2.208-2.75 2.748m2.006-2.749H1.832"
  })));
};
export default SvgIconAiModelPositionButton;